import { computed, defineComponent, reactive, ref, toRaw, watch } from "vue";
import { Form } from "ant-design-vue";
import { mergeAjaxDataToForm } from "@/utils";
// 新增品牌组件在公共组件使用到 MaterialCategorySelect 必须通过完整路径引入
import MaterialCategorySelect from "@/components/material-category-select/index.vue";
import { formRules } from "./form-btn.constant";
import { BrandService } from "../../brand.service";
import { BrandReq, BrandPageResp } from "../../brand.interface";
export default defineComponent({
  name: "FormBtn",
  components: { MaterialCategorySelect },
  props: {
    id: {
      type: String,
      default: "",
    },
    defaultBrand: {
      type: String,
      default: "",
    },
    materialCategoryId: {
      type: String,
      default: null,
    },
    isRelative: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    refresh: null,
  },
  setup(props, { attrs, slots, emit }) {
    let cachedVal = "";
    const name = ref();
    const fetching = ref(false);
    const visible = ref(false);
    const isEdit = computed(() => !!props.id);
    const formRef = reactive(new BrandReq());
    const ruleRef = reactive(formRules);
    const { resetFields, validate, validateInfos } = Form.useForm(formRef, ruleRef);

    const { run: runDetail, loading: detailLoading } = BrandService.useDetailApi();
    const { run: runCreate, loading: createLoading } = BrandService.useCreateApi();
    const { run: runEdit, loading: editLoading } = BrandService.useEditApi();
    const { data, run, loading } = BrandService.usePageApi();

    const showCreateModal = async () => {
      visible.value = true;
      if (props.materialCategoryId) formRef.materialCategoryId = [props.materialCategoryId];
      if (props.defaultBrand) formRef.name = props.defaultBrand.length > 20?props.defaultBrand.slice(0,20):props.defaultBrand;
    };

    const showEditModal = async () => {
      visible.value = true;
      if (isEdit.value) {
        const res = await runDetail(props.id);
        if (res.respCode === "0000") {
          mergeAjaxDataToForm(res.data, formRef);
        }
      }
    };

    const closeModal = () => {
      resetFields();
      visible.value = false;
    };

    const submit = async () => {
      try {
        await validate();
        const cacheParams = { ...formRef };
        cacheParams.materialCategoryId = [...cacheParams.materialCategoryId];

        cacheParams.materialCategoryId = cacheParams.materialCategoryId.map((ele) => {
          if (typeof ele === "object") {
            return (ele as any).value;
          } else {
            return ele;
          }
        });
        const res = isEdit.value
          ? await runEdit(props.id, cacheParams)
          : await runCreate(cacheParams);
        if (res.respCode === "0000") {
          emit("refresh", { ...cacheParams, id: res.data?.id || null });
          closeModal();
          name.value = undefined;
        }
      } catch (e) {
        console.log("e", e);
      }
    };
    const handleSearch = (value) => {
      if (value && value.length > 0) {
        cachedVal = value;
        fetch(value);
      }
    };
    const handleChange = (value) => {
      console.log(formRef, 11);
      formRef.name = value;
      // fetch(value);
    };

    let timeout;
    let currentValue;
    const fetch = (value) => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      currentValue = value;

      async function fake() {
        let params = {
          current: 1,
          size: 50,
          name: currentValue,
        };
        const list = await run(params);
        let t = new BrandPageResp();
        t.name = formRef.name;
        list.data.records.push(t);
        return t;
      }
      timeout = setTimeout(fake, 800);
    };
    const blurFn = () => {
      console.log(999999);
      name.value = cachedVal;
      formRef.name = cachedVal;
      console.log("blur", name.value, cachedVal, formRef.name);
    };
    return {
      visible,
      isEdit,
      formRef,
      ruleRef,
      validateInfos,
      detailLoading,
      createLoading,
      editLoading,
      showCreateModal,
      showEditModal,
      submit,
      closeModal,
      handleSearch,
      handleChange,
      fetch,
      data,
      fetching,
      name,
      formRules,
      blurFn,
    };
  },
});
